import React, { useEffect, useRef } from 'react';
interface IProps {
  code: any;
}

const Zendesk = (props: IProps): any => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return null;
    const script = document.createElement('script');
    script.id = 'ze-snippet'
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${props.code}`;
    script.type = 'text/javascript';
    script.async = true;
    ref.current.appendChild(script);

    return () => {
      const launcher = document.getElementById('launcher');
      launcher?.parentNode.removeChild(launcher);
      const widget = document.querySelector('[data-product="web_widget"]');
      widget?.parentNode.removeChild(widget);
      delete (window as any).$zopim
    }

  }, [props.code])

  return (
    <div ref={ref} />
  );
}

export default Zendesk;